import { Component, OnInit, inject } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import {
  AuthService,
  ChatService,
  MemberService,
  MenuDataService,
} from 'shared';
import { RouterOutlet } from '@angular/router';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: true,
    imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  private primengConfig = inject(PrimeNGConfig);
  private menuDataService = inject(MenuDataService);
  private authService = inject(AuthService);
  private memberService = inject(MemberService);
  private chatService = inject(ChatService);

  model: any = [
    {
      label: '',
      icon: 'pi pi-fw pi-sitemap',
      items: [
        {
          label: 'Πίνακας Ελέγχου',
          icon: 'pi pi-fw pi-home',
          routerLink: [''],
        },
        {
          label: 'Διαχείριση Παροχών',
          icon: 'pi pi-fw pi-briefcase',
          routerLink: ['/insurance-management'],
        },
        {
          label: 'Διαχείριση Πελατών',
          icon: 'pi pi-fw pi-users',
          routerLink: ['/client-management'],
        },
        {
          label: 'Διαχείριση Αποζημιώσεων',
          icon: 'pi pi-fw pi-wallet',
          routerLink: ['/agency-management'],
        },
      ],
    },
  ];

  ngOnInit(): void {
    this.primengConfig.ripple = true;
    this.menuDataService.update(this.model);
    this.memberService.appName = 'doctor';
    const user = JSON.parse(localStorage.getItem('token')!);
    if (user) {
      this.authService.fetchUser(user).subscribe(() => {
        this.chatService.createCurrentSession();
      });
    }
  }
}
